import {
    GET_PURCHASE_REGISTER_REPORT_PROGRESS, GET_PURCHASE_REGISTER_REPORT_SUCCESS, GET_PURCHASE_REGISTER_REPORT_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    purchaseRegister: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const purchase_register_report_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PURCHASE_REGISTER_REPORT_SUCCESS:
            return { ...state, purchaseRegister: action.purchaseRegister, loading: false };
        case GET_PURCHASE_REGISTER_REPORT_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_PURCHASE_REGISTER_REPORT_PROGRESS:
            return { ...state, loading: true, error: false };

        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default purchase_register_report_reducer;